import React from 'react'
import styled from 'styled-components'

import Header from './header'
import Footer from './footer'

import './layout.sass'

export default styled(({ className, children }) =>
  <div className={className}>
    <Header />
    <main>{children}</main>
    <Footer />
  </div>
)`

`
